import { render, staticRenderFns } from "./SendMessages.vue?vue&type=template&id=052ee5ff&"
import script from "./SendMessages.vue?vue&type=script&lang=js&"
export * from "./SendMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports